import { render, staticRenderFns } from "./UnassignedTicketsTable.vue?vue&type=template&id=efce79d8&"
import script from "./UnassignedTicketsTable.vue?vue&type=script&lang=js&"
export * from "./UnassignedTicketsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports